import { Component, Vue } from 'vue-property-decorator'
import { getMarketClueById } from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'

@Component({
})
export default class SeeClue extends Vue {
    // ------ 变量 ------
    marketClue: any = {}
    activities = []
    operationShow = true
    marketId = 0
    status = ''
    loading = false

    // ------ 生命周期 ------
    created() {
        this.marketId = Number(this.$route.query.id)
        this.status = (this.$route.query.status as string) || ''
        this.getMarketClueById()
    }

    // ------ 方法 ------
    async getMarketClueById() {
        this.loading = true
        await getMarketClueById({ id: this.marketId }).then((data: any)=>{
            this.marketClue = data.marketClue
            this.activities = this.marketClue.market_clue_logs
            this.loading = false
        }).catch(()=>{
            this.loading = false
        })

    }
    formatDate(format: string, val: Date) {
        return formatDate(format, new Date(val))
    }
    buttonShow(id: number): boolean {
        return menuBtn(id)
    }
}